import React from "react";
import LaunchedCarSlider from "../../components/lunchedCarsSlider";
import { lightText } from "../../constants/colors";
const UpComingCars = () => {
  return (
    <div className="lg:w-[1320px] m-auto">
      <div className="ps-4 lg:ps-none mb-8">
        <p className="text-[40px] font-bold">Upcoming Cars</p>
        <p className="mb-20 lg:mb-8" style={{ color: lightText }}>
          Here are some of the featured cars in different categories
        </p>
      </div>
      <LaunchedCarSlider />
    </div>
  );
};

export default UpComingCars;
